import * as React from "react";
import { SimpleForm, TextInput, Edit, EditProps } from "react-admin";

export const EditStatus: React.FC<EditProps> = (props) => {
  return (
    <Edit {...props} mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="name" fullWidth required label="Nombre" />
      </SimpleForm>
    </Edit>
  );
};
